import script from "./AnimationSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimationSelect.vue?vue&type=script&setup=true&lang=js"

import "./AnimationSelect.vue?vue&type=style&index=0&id=56d1db0a&lang=scss&scoped=true"

import exportComponent from "D:\\work\\project\\week-alone\\weekly-alone-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d1db0a"]])

export default __exports__